var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":true,"opacity":0.4,"value":_vm.asset.maintenance}},[_c('div',{staticClass:"text-center"},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-wrench")]),_c('div',{staticClass:"text-h4"},[_vm._v("อยู่ระหว่างการซ่อมบำรุง")]),_c('ASSET_MENU',{staticClass:"mt-4",attrs:{"asset":_vm.asset,"align":'center'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }